var map = {
	"./1INCH.png": "1e25",
	"./3077.png": "7908",
	"./AAVE.png": "ef69",
	"./ADA.png": "4749",
	"./ALGORAND.png": "3882",
	"./ATOM.png": "1020",
	"./AVALANCHE.png": "61b5d",
	"./AVAX.png": "6c04",
	"./BCH.png": "8768",
	"./BINANCE.png": "aa76",
	"./BINANCE_COIN.png": "3422",
	"./BINANCE_COIN_BSC.png": "95b0",
	"./BITCOIN.png": "5189",
	"./BITCOIN_CASH.png": "aadc",
	"./BNB.png": "0729",
	"./BTC.png": "9c3f",
	"./CAKE.png": "0018",
	"./CELO.png": "1034",
	"./CHAIN_LINK.png": "8ece",
	"./CLASSIC_ETHEREUM.png": "0c02",
	"./COMP.png": "e871",
	"./COMPOUND.png": "ad2f",
	"./COSMOS.png": "7b4b",
	"./CRO.png": "2d85",
	"./DASH.png": "a6ea",
	"./DCR.png": "d3f7",
	"./DECRED.png": "0f95",
	"./DODO.png": "81b0",
	"./DOGE.png": "4e9e",
	"./DOGE_COIN.png": "252d",
	"./DOT.png": "91ce",
	"./EGLD.png": "dce2",
	"./ELROND.png": "872e",
	"./EOS.png": "dd89",
	"./ETC.png": "89c3",
	"./ETH.png": "439b",
	"./ETHEREUM.png": "31ad",
	"./FANTOM.png": "6bd2",
	"./FIL.png": "dfa0",
	"./FILE_COIN.png": "90d3",
	"./FLOW.png": "2767",
	"./FTM.png": "4a55",
	"./FTT.png": "97ad",
	"./FTX.png": "73b0",
	"./GRT.png": "574f",
	"./HARMONY_ONE.png": "61a3",
	"./HOLO.png": "e6d5",
	"./HOT.png": "4d3e",
	"./HT.png": "8177",
	"./LEO.png": "ad74",
	"./LINK.png": "109e",
	"./LITE.png": "16f3",
	"./LITE_COIN.png": "9fe0",
	"./LTC.png": "1a76",
	"./LUNA.png": "8837",
	"./MATIC.png": "fbb1",
	"./MATIC1.png": "d14c",
	"./MIOTA.png": "0c83",
	"./MONERO.png": "c477",
	"./NEM.png": "2785",
	"./NEO.png": "ec9f",
	"./ONE.png": "e318",
	"./ONE_INCH.png": "9a92",
	"./POLKADOT.png": "59d2",
	"./QTUM.png": "9070",
	"./REEF.png": "b955",
	"./REEF_FINANCE.png": "1947",
	"./RIPPLE.png": "da68",
	"./SHIB.png": "d2e6",
	"./SHIBA_INU.png": "80f1",
	"./SNX.png": "d612",
	"./SOL.png": "9a95",
	"./SOLANA.png": "6def",
	"./STELLAR.png": "0dae",
	"./SUSHI.png": "9668",
	"./SYNTHETIX.png": "00da",
	"./TERRA.png": "03ff",
	"./TETHER.png": "01e3",
	"./TEZOS.png": "235e",
	"./THE_GRAPH.png": "4af5",
	"./TOMAN.png": "2982",
	"./TOMO.png": "3e57",
	"./TOMO_CHAIN.png": "33f1",
	"./TRON.png": "9da8",
	"./TRX.png": "44ff",
	"./UNI.png": "fb5c",
	"./UNI_SWAP.png": "4770",
	"./USDT.png": "97a0",
	"./VECHAIN.png": "7a2a",
	"./VET.png": "095a",
	"./VE_CHAIN.png": "f9981",
	"./WAVES.png": "c591",
	"./XEM.png": "983a",
	"./XLM.png": "80ef",
	"./XMR.png": "7ce2",
	"./XRP.png": "da4c",
	"./XTZ.png": "2d5a",
	"./ZEC.png": "14ba",
	"./ZIL.png": "7991",
	"./ZILLIQA.png": "ceb6",
	"./Z_CASH.png": "62fb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cd32";